import { useParams } from 'react-router-dom';
import { bultenler } from '../pages/data/Bultenler';

const BultenDetay = () => {
  const { bultenId } = useParams();
  const bulten = bultenler.find(b => b.id === bultenId);

  if (!bulten) return <div>Bülten bulunamadı</div>;

  return (
    <div className="px-4 md:px-16 py-20 space-y-6" style={{ backgroundImage: "url('/background.png')" }}>
      <h1 className="text-3xl font-bold text-[#a03838]">{bulten.title}</h1>
      <p>{bulten.description}</p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
        {bulten.gallery.map((src, idx) => (
          <img key={idx} src={src} alt={`Bülten görseli ${idx}`} className="rounded shadow" />
        ))}
      </div>

      {bulten.video && (
        <div className="mt-8">
          <iframe
            className="w-full h-64 md:h-96 rounded"
            src={bulten.video}
            title={bulten.title}
            allowFullScreen
          />
        </div>
      )}
    </div>
  );
};

export default BultenDetay;
